{
  "general": {
    "dateFormat": "dd/MM/yyyy",
    "fullDateFormat": "dd/MM/yyyy HH:mm:ss",
    "logout": "Sair",
    "account": "Conta",
    "profile": "Perfil",
    "hello": "Olá",
    "home": "Início",
    "loading": "Carregando...",
    "confirm": "Confirmar",
    "cancel": "Cancelar",
    "close": "Fechar",
    "save": "Salvar",
    "records": "Registros",
    "add": "Adicionar",
    "read": "Ler",
    "write": "Salvar",
    "edit": "Editar",
    "new": "Novo",
    "delete": "Excluir",
    "actions": "Ações",
    "active": "Ativo",
    "inactive": "Inativo",
    "search": "Pesquisar",
    "yes": "Sim",
    "no": "Não",
    "years": "Anos",
    "months": "Meses",
    "favorites": "Favoritos",
    "reports": "Relatórios",
    "recordsPerPage": "Registros por página",
    "changePassword": "Alterar senha",
    "longDateFormat": "{years} ano(s) e {months} mês(es)",
    "importData": "Importar dados",
    "upload": "Enviar",
    "downloadTemplate": "Baixar modelo",
    "selectOption": "Selecione uma opção",
    "id": "ID",
    "translations": "Traduções",
    "or": "ou",
    "review": "Revisar",
    "approve": "Aprovar",
    "reject": "Rejeitar",
    "reviewComments": "Comentários de Revisão",
    "reviewOnBehalfOf": "Revisar em nome de",
    "reviewed": "Revisado",
    "reviewedBy": "Revisado Por ",
    "pending": "Pendente",
    "approved": "Aprovado",
    "rejected": "Rejeitado",
    "skipped": "Ignorado",
    "warning": "Aviso",
    "leave": "Sair",
    "export": "Exportar",
    "import": "Importar",
    "next": "Próximo",
    "previous": "Anterior",
    "done": "Concluído",
    "permissionActions": {
      "read": "Ler",
      "write": "Escrever",
      "delete": "Excluir",
      "execute": "Executar"
    },
    "messages": {
      "formUnsavedChanges": "Você tem alterações não salvas. Tem certeza de que deseja fechar?",
      "serverError": "Erro do servidor. Por favor, tente novamente mais tarde ou entre em contato com o administrador do sistema.",
      "networkError": "Não foi possível conectar ao servidor. Verifique sua conexão com a internet ou entre em contato com o administrador do sistema.",
      "forbidden": "Você não tem permissão para acessar este recurso. Entre em contato com o administrador do sistema se achar que isso é um erro.",
      "fileUploadError": "Erro ao enviar o arquivo. Verifique o formato e o tamanho do arquivo e tente novamente.",
      "fileUploadSuccessEmail": "Arquivo enviado com sucesso. Um e-mail com o resultado da importação será enviado em breve.",
      "failedLoadPermissions": "Falha ao carregar as permissões do usuário. Por favor, atualize a página ou entre em contato com o administrador do sistema.",
      "downloadingFile": "Baixando arquivo...",
      "fileDownloadError": "Erro ao baixar o arquivo. Por favor, tente novamente ou entre em contato com o administrador do sistema.",
      "fileImportedSuccessfully": "Arquivo importado com sucesso."
    },
    "warnings": {
      "maxDisplayedRecords": "O número máximo de registros exibidos é 500. Para ver mais registros, use a pesquisa."
    },
    "validation": {
      "required": "Este campo é obrigatório.",
      "email": "Por favor, insira um endereço de e-mail válido.",
      "minValue": "O valor deve ser pelo menos {min}.",
      "maxValue": "O valor não pode ser maior que {max}.",
      "onlyIntegers": "O valor deve ser um número inteiro.",
      "invalidDate": "A data informada é inválida."
    },
    "baseAuditableEntity": {
      "createdBy": "Criado por",
      "createdDate": "Data de criação",
      "modifiedBy": "Modificado por",
      "modifiedDate": "Data de modificação"
    }
  },
  "reportViewer": {
    "noFilterMessage": "Nenhum filtro para este relatório",
    "noAccessReport": "Você não tem acesso para visualizar este relatório. Entre em contato com o administrador do sistema se achar que isso é um erro.",
    "pdfSizeErrorMessage": "O tamanho do PDF é muito grande e não pode ser exibido.",
    "pdfMaxSizeDownloaded": "O relatório é muito grande para ser exibido. Verifique sua pasta de downloads.",
    "failedLoadReports": "Falha ao carregar relatórios. Outros recursos funcionarão normalmente. Por favor, atualize a página ou entre em contato com o administrador do sistema se o problema persistir.",
    "run": "Executar",
    "download": "Baixar",
    "viewFilter": {
      "button": "Ver Filtros...",
      "title": "Parâmetros",
      "name": "Nome",
      "value": "Valor"
    },
    "fullScreen": "Tela Cheia...",
    "smallScreen": "Tela Pequena...",
    "tabButton": {
      "fullScreen": "Ocultar seção de parâmetros",
      "smallScreen": "Mostrar seção de parâmetros",
      "about": "Sobre",
      "downloadExcel": "Baixar arquivo de Planilha",
      "clear": "Fechar Todas as Abas"
    },
    "modalAbout": {
      "title": "Sobre",
      "description": "Descrição",
      "version": "Versão",
      "reference": "Referência",
      "lastChange": "Última Alteração",
      "dataSource": "Fonte de Dados"
    }
  },
  "file": {
    "description": "Descrição",
    "files": "Arquivos",
    "editDescription": "Editar Descrição",
    "delete": "Excluir Arquivo",
    "download": "Baixar Arquivo",
    "pendingUpload": "Upload pendente. O arquivo só será salvo após clicar em 'Salvar'.",
    "noFiles": "Nenhum arquivo adicionado."
  },
  "404": {
    "title": "Esta página não foi encontrada.",
    "text": "A página solicitada não pôde ser encontrada.",
    "back_button": "Voltar para o painel"
  },
  "403": {
    "title": "Você não tem permissão para acessar esta página.",
    "text": "Se você acha que isso é um erro, por favor, entre em contato com o administrador.",
    "back_button": "Voltar para o painel"
  },
  "401": {
    "title": "Você não está autorizado a acessar esta página.",
    "text": "Se você acha que isso não está certo, entre em contato com o administrador",
    "back_button": "Voltar para o painel"
  },
  "dashboard": {
    "menuTitle": "Painel",
    "title": "Painel",
    "addWidget": "Adicionar Widget",
    "editLayout": "Editar Layout",
    "saveLayout": "Salvar Layout",
    "importLayout": "Importar Layout",
    "exportLayout": "Exportar Layout",
    "category": "Categoria",
    "widget": "Widget",
    "widgetTitle": "Título",
    "widgetParameters": "Parâmetros",
    "widgetInformation": "Informações do Widget",
    "noParameters": "Este widget não possui parâmetros.",
    "delete": "Excluir Widget",
    "viewLink": "visualizar",
    "messages": {
      "saveSuccess": "Layout salvo com sucesso.",
      "importSuccess": "Layout importado com sucesso.",
      "exportSuccess": "Layout exportado com sucesso.",
      "importFailed": "Falha ao importar layout.",
      "widgetNotFound": "Widget não encontrado",
      "failedToLoad": "Falha ao carregar",
      "noDataAvailable": "Nenhum dado disponível"
    },
    "tutorial": {
      "mainMessage": "Bem-vindo ao seu painel! Use os botões acima para personalizá-lo.",
      "callToAction": "Mostre-me como!",
      "instructions": {
        "add": {
          "title": "Botão Adicionar Widget",
          "description": "Aqui você poderá encontrar widgets por categoria. Alguns deles podem ter parâmetros para permitir um dashboard totalmente personalizável. Não se esqueça de clicar em SALVAR após adicionar todos os seus widgets."
        },
        "edit": {
          "title": "Botão Editar Layout do Widget",
          "description": "Aqui você poderá alterar seu dashboard: Adicionar ou remover widgets, movê-los e redimensioná-los. Não se esqueça de salvar após editar."
        },
        "import": {
          "title": "Botão Importar Layout",
          "description": "Com um arquivo de backup, aqui você pode importá-lo. Nota: Seu dashboard será substituído."
        },
        "export": {
          "title": "Botão Exportar Layout",
          "description": "Uma vez que seu dashboard estiver completo, você pode exportá-lo para ter um backup OU enviá-lo para outro usuário copiar seu dashboard."
        }
      }
    }
  },
  "settings": {
    "title": "Configurações",
    "theme": {
      "name": "Tema",
      "dark": "Escuro",
      "light": "Claro"
    }
  },
  "userInfo": {
    "title": "Informações do Usuário",
    "permissions": "Permissões",
    "userName": "Nome de Usuário",
    "fullName": "Nome Completo",
    "email": "E-mail",
    "employeeId": "ID do Funcionário",
    "action": "Ação",
    "permissionCode": "Código de Permissão"
  },
  "impersonate": {
    "title": "Personificar Usuário",
    "userName": "Login",
    "start": "Iniciar Personificação",
    "messages": {
      "impersonationStarted": "Sessão de personificação iniciada. Para retornar à sua conta, faça logout e login novamente.",
      "userNotFound": "Usuário não encontrado. Por favor, verifique o nome de usuário e tente novamente."
    }
  },
  "about": {
    "menuName": "Sobre",
    "title": "Sobre"
  },
  "releaseNotes": {
    "menuName": "Notas de Lançamento",
    "title": "Notas de Lançamento",
    "name": "Nome",
    "version": "Versão",
    "description": "Descrição",
    "appType": "Tipo de Aplicação",
    "releaseDate": "Data de Lançamento",
    "messages": {
      "notFound": "Nota de lançamento não encontrada.",
      "saveError": "Erro ao salvar nota de lançamento. Por favor, tente novamente mais tarde."
    }
  },
  "admin": {
    "menuTitle": "Administração",
    "menuHierarchy": {
      "menuName": "Hierarquia do Menu",
      "pageTitle": "Hierarquia do Menu",
      "displayName": "Nome de Exibição",
      "routeParam": "Parâmetro do Menu",
      "securityResources": "Recursos de Segurança",
      "children": "Sub-Menus",
      "isActive": "Está Ativo",
      "icon": "Ícone",
      "displayOrder": "Ordem de Exibição",
      "edit": "Editar Item do Menu",
      "messages": {
        "success": "Item do menu salvo com sucesso."
      }
    },
    "notificationTemplate": {
      "menuName": "Modelo de Notificação",
      "pageTitle": "Modelo de Notificação",
      "name": "Nome",
      "parent": "Modelo Pai",
      "parentInfo": "Apenas modelos que começam com masterTemplate podem ser usados como modelo pai.",
      "pushNotificationEnabled": "Notificação Push Habilitada",
      "pushRoute": "Rota de Notificação Push",
      "sqlQuery": "Consulta SQL",
      "sqlQueryDateFormatInfo": "Colunas de data devem ser formatadas no formato MM/dd/yyyy.",
      "generalSection": "Informações Gerais",
      "emailSection": "Notificação por E-mail",
      "emailSubject": "Assunto do E-mail",
      "emailBody": "Corpo do E-mail (HTML)",
      "pushSection": "Notificação Push",
      "pushSubject": "Assunto Push",
      "pushBody": "Corpo Push",
      "overrideNotificationTemplate": "Sobrescrever Modelo de Notificação",
      "add": "Adicionar Modelo",
      "edit": "Editar Modelo",
      "delete": {
        "title": "Excluir Modelo",
        "text": "Tem certeza de que deseja excluir o modelo \"{name}\"?"
      },
      "messages": {
        "created": "Modelo de notificação criado com sucesso.",
        "updated": "Modelo de notificação atualizado com sucesso.",
        "deleted": "Modelo de notificação excluído com sucesso.",
        "alreadyExists": "Um modelo de notificação com este nome já existe.",
        "fileRequired": "O arquivo é obrigatório.",
        "importError": "Ocorreu um erro ao importar o modelo de notificação."
      }
    },
    "department": {
      "menuName": "Departamento",
      "pageTitle": "Departamento",
      "name": "Nome",
      "isActive": "Está Ativo",
      "add": "Adicionar Departamento",
      "edit": "Editar Departamento",
      "delete": {
        "title": "Excluir Departamento",
        "text": "Tem certeza de que deseja excluir este departamento?"
      },
      "messages": {
        "created": "Departamento criado com sucesso.",
        "updated": "Departamento atualizado com sucesso.",
        "deleted": "Departamento excluído com sucesso."
      }
    },
    "businessArea": {
      "menuName": "Área de Negócio",
      "pageTitle": "Área de Negócio",
      "id": "Id",
      "externalId": "Id Externo",
      "description": "Descrição",
      "calendarId": "Calendário",
      "isActive": "Está Ativo",
      "edit": "Editar Área de Negócio",
      "messages": {
        "created": "Área de Negócio criada com sucesso.",
        "updated": "Área de Negócio atualizada com sucesso.",
        "deleted": "Área de Negócio excluída com sucesso."
      }
    },
    "configuration": {
      "menuName": "Configuração",
      "pageTitle": "Configuração",
      "key": "Chave",
      "value": "Valor",
      "editorType": "Tipo",
      "add": "Adicionar Configuração",
      "edit": "Editar Configuração",
      "delete": {
        "title": "Excluir Configuração",
        "text": "Tem certeza de que deseja excluir esta configuração?"
      },
      "messages": {
        "created": "Configuração criada com sucesso.",
        "updated": "Configuração atualizada com sucesso.",
        "deleted": "Configuração excluída com sucesso."
      },
      "types": {
        "text": "Texto",
        "string": "String",
        "number": "Número",
        "int": "Inteiro",
        "boolean": "Booleano"
      }
    },
    "widget": {
      "menuName": "Widget",
      "pageTitle": "Widget",
      "name": "Nome",
      "description": "Descrição",
      "securityResources": "Recursos de Segurança",
      "link": "Link",
      "query": "Consulta SQL",
      "queryRequired": "Consulta SQL é obrigatória.",
      "sqlQueryDateFormatInfo": "Colunas de data devem ser formatadas no formato MM/dd/yyyy.",
      "minHeight": "Altura Mínima",
      "minWidth": "Largura Mínima",
      "type": "Tipo",
      "category": "Categoria",
      "add": "Adicionar Widget",
      "edit": "Editar Widget",
      "delete": {
        "title": "Excluir Widget",
        "text": "Tem certeza de que deseja excluir este widget?"
      },
      "examples": {
        "viewSQLExamples": "Ver exemplos de SQL",
        "general": "Geral",
        "generalDescription": "Por padrão, o sistema fornece os seguintes parâmetros, que podem ser referenciados diretamente em qualquer consulta SQL de widget.",
        "loggedUserNameDescription": "Nome de usuário de login do usuário atualmente logado (por exemplo: {email}).",
        "loggedUserEmployeeIdDescription": "Identificador do funcionário do usuário atualmente logado.",
        "loggedUserLanguageDescription": "Código do idioma do usuário atualmente logado (por exemplo: en-US, pt-BR).",
        "listDescription": "Cada linha representa um item da lista.",
        "numberDescription": "Retorna um único valor numérico.",
        "donutDescription": "Rótulos e valores devem estar alinhados por posição.",
        "lineDescription": "Cada linha representa uma série de linha."
      },
      "messages": {
        "created": "Widget criado com sucesso.",
        "updated": "Widget atualizado com sucesso.",
        "deleted": "Widget excluído com sucesso.",
        "fileRequired": "O arquivo é obrigatório.",
        "importError": "Ocorreu um erro ao importar o widget.",
        "queryVariablesMissing": "As seguintes variáveis estão faltando na consulta do widget: \"{variables}\". Por favor, adicione-as à consulta para garantir o funcionamento correto."
      }
    },
    "widgetCategory": {
      "menuName": "Categoria de Widget",
      "pageTitle": "Categoria de Widget",
      "name": "Nome",
      "description": "Descrição",
      "type": "Tipo",
      "add": "Adicionar Categoria de Widget",
      "edit": "Editar Categoria de Widget",
      "delete": {
        "title": "Excluir Categoria de Widget",
        "text": "Tem certeza de que deseja excluir esta categoria de widget?"
      },
      "messages": {
        "created": "Categoria de Widget criada com sucesso.",
        "updated": "Categoria de Widget atualizada com sucesso.",
        "deleted": "Categoria de Widget excluída com sucesso."
      }
    },
    "widgetType": {
      "menuName": "Tipo de Widget",
      "pageTitle": "Tipo de Widget",
      "name": "Nome",
      "types": {
        "number": "Número",
        "list": "Lista",
        "donut": "Rosca",
        "line": "Linha"
      }
    },
    "widgetParameter": {
      "menuName": "Parâmetro de Widget",
      "menuTitle": "Parâmetro de Widget",
      "title": "Parâmetro de Widget",
      "name": "Nome",
      "nameInfo": "Nome usado para identificar o parâmetro na consulta SQL do widget. Não use espaços ou caracteres especiais.",
      "nameUniqueError": "Um Parâmetro de Widget com este nome já existe.",
      "description": "Descrição",
      "isRequired": "É Obrigatório?",
      "isMultiple": "É Múltiplo?",
      "status": "Status",
      "edit": "Editar Parâmetro de Widget",
      "add": "Adicionar Parâmetro de Widget",
      "type": "Tipo",
      "data": "Consulta SQL",
      "dataInfo": "A consulta SQL deve retornar duas colunas chamadas 'Value' e 'Text'.",
      "listOfValues": "Lista de Valores",
      "addValue": "Adicionar Valor",
      "value": "Valor",
      "label": "Rótulo",
      "delete": {
        "title": "Excluir Parâmetro de Widget",
        "text": "Tem certeza de que deseja excluir {name}?"
      },
      "types": {
        "text": "Texto",
        "number": "Número",
        "date": "Data",
        "boolean": "Booleano",
        "select": "Lista",
        "sql": "Lista de Consulta"
      },
      "messages": {
        "notFound": "Parâmetro de Widget não encontrado.",
        "saveSuccess": "Parâmetro de Widget salvo com sucesso.",
        "saveError": "Ocorreu um erro ao salvar o Parâmetro de Widget.",
        "deleteSuccess": "Parâmetro de Widget excluído com sucesso.",
        "deleteError": "Ocorreu um erro ao excluir o Parâmetro de Widget.",
        "isInUse": "Não é possível excluir o Parâmetro de Widget porque está em uso."
      }
    },
    "people": {
      "employeeId": "ID do Funcionário",
      "name": "Nome",
      "position": "Cargo",
      "person": "Pessoa",
      "personTypes": {
        "unknown": "Desconhecido",
        "salariedEmployee": "Funcionário Assalariado",
        "contractor": "Contratado",
        "vendor": "Fornecedor",
        "hourlyEmployee": "Funcionário Horista",
        "external": "Externo",
        "duHourlyInactive": "DU Horista Inativo",
        "duSalariedInactive": "DU Assalariado Inativo",
        "duTruckDriverIn": "DU Motorista de Caminhão Em",
        "executive": "Executivo",
        "union": "Sindicalizado",
        "nonUnion": "Não Sindicalizado",
        "unionPossible": "Sindicalização Possível",
        "salariedNonExempt": "Assalariado Não Isento",
        "hourly": "Horista",
        "duPaidLeave": "DU Licença Remunerada",
        "truckDriver": "Motorista de Caminhão",
        "duUnpaidLeave": "DU Licença Não Remunerada",
        "workRelease": "Liberação de Trabalho",
        "externalAccessLevelOne": "Acesso Externo Nível Um",
        "externalAccessLevelTwo": "Acesso Externo Nível Dois",
        "externalAccessLevelThree": "Acesso Externo Nível Três",
        "externalAccessLevelFour": "Acesso Externo Nível Quatro",
        "externalAccessLevelFive": "Acesso Externo Nível Cinco",
        "globalEmployee": "Funcionário Global"
      }
    }
  },
  "vuestic": {
    "search": "Pesquisar",
    "noOptions": "Itens não encontrados",
    "ok": "OK",
    "cancel": "Cancelar",
    "uploadFile": "Selecionar arquivo",
    "undo": "Desfazer",
    "dropzone": "Solte os arquivos aqui para enviar",
    "fileDeleted": "Arquivo excluído",
    "closeAlert": "fechar alerta",
    "backToTop": "voltar ao topo",
    "toggleDropdown": "alternar menu suspenso",
    "carousel": "carrossel",
    "goPreviousSlide": "ir para o slide anterior",
    "goNextSlide": "ir para o próximo slide",
    "goSlide": "ir para o slide {index}",
    "slideOf": "slide {index} de {length}",
    "close": "fechar",
    "openColorPicker": "abrir seletor de cor",
    "colorSelection": "seleção de cor",
    "colorName": "cor {color}",
    "decreaseCounter": "diminuir contador",
    "increaseCounter": "aumentar contador",
    "selectAllRows": "selecionar todas as linhas",
    "sortColumnBy": "ordenar coluna por {name}",
    "selectRowByIndex": "selecionar linha {index}",
    "resetDate": "redefinir data",
    "nextPeriod": "próximo período",
    "switchView": "alternar visualização",
    "previousPeriod": "período anterior",
    "removeFile": "remover arquivo",
    "reset": "redefinir",
    "pagination": "paginação",
    "goToTheFirstPage": "ir para a primeira página",
    "goToPreviousPage": "ir para a página anterior",
    "goToSpecificPage": "ir para a página {page}",
    "goToSpecificPageInput": "inserir número da página",
    "goNextPage": "ir para a próxima página",
    "goLastPage": "ir para a última página",
    "currentRating": "classificação atual {value} de {max}",
    "voteRating": "votar classificação {value} de {max}",
    "optionsFilter": "filtro de opções",
    "splitPanels": "dividir painéis",
    "movePaginationLeft": "mover paginação para a esquerda",
    "movePaginationRight": "mover paginação para a direita",
    "resetTime": "redefinir hora",
    "closeToast": "fechar notificação",
    "selectedOption": "Opção selecionada",
    "noSelectedOption": "Nenhuma opção selecionada",
    "breadcrumbs": "migalhas de pão",
    "counterValue": "valor do contador",
    "selectedDate": "data selecionada",
    "selectedTime": "hora selecionada",
    "progressState": "estado do progresso",
    "color": "cor",
    "next": "Próximo",
    "back": "Voltar",
    "finish": "Finalizar",
    "step": "passo",
    "progress": "progresso",
    "loading": "Carregando",
    "sliderValue": "O valor atual do controle deslizante é {value}",
    "switch": "Alternar",
    "inputField": "Campo de entrada",
    "fileTypeIncorrect": "Tipo de arquivo incorreto",
    "select": "Selecionar uma opção"
  }
}
